
import Component from 'vue-class-component';
import BaseGridForm from './BaseGridForm';

@Component({})
export default class GridForm extends BaseGridForm {}
